import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear cart na succesvolle betaling
    localStorage.removeItem("cart");
    // Trigger cart update event
    window.dispatchEvent(new Event('cartUpdated'));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Bedankt voor je bestelling | Bo Barbers"
        description="Je betaling is gelukt. Zodra je bestelling wordt verzonden ontvang je automatisch een verzendbevestiging met track & trace."
        path="/payment-success"
      />
      <Header />
      
      <section className="flex-1 flex items-center justify-center py-32 px-6 bg-background">
        <div className="container mx-auto max-w-2xl text-center">
          <div className="mb-8 flex justify-center">
            <CheckCircle className="w-24 h-24 text-primary animate-fade-in" />
          </div>
          
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-6 text-foreground animate-fade-in" style={{ animationDelay: "0.2s", animationFillMode: "forwards" }}>
            BEDANKT VOOR JE BESTELLING!
          </h1>
          
          <div className="w-24 h-1 bg-foreground mx-auto mb-8 animate-fade-in" style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}></div>
          
          <p className="text-foreground/70 text-lg mb-4 leading-relaxed animate-fade-in" style={{ animationDelay: "0.6s", animationFillMode: "forwards" }}>
            Wij versturen geen aparte bestelbevestiging per e-mail. Zodra je bestelling wordt verzonden, ontvang je automatisch een e-mail met de verzendbevestiging en track &amp; trace-gegevens.
          </p>
          
          <p className="text-foreground/60 mb-12 animate-fade-in" style={{ animationDelay: "0.8s", animationFillMode: "forwards" }}>
            Bestellingen die op werkdagen vóór 15:00 uur worden geplaatst, worden dezelfde dag verzonden. In het weekend vinden geen verzendingen plaats.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{ animationDelay: "1s", animationFillMode: "forwards" }}>
            <Button
              onClick={() => navigate("/")}
              size="lg"
              className="rounded-full px-8"
            >
              TERUG NAAR HOME
            </Button>
            <Button
              onClick={() => navigate("/products")}
              variant="outline"
              size="lg"
              className="rounded-full px-8"
            >
              VERDER WINKELEN
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PaymentSuccess;
